import React from 'react';

const AvisoPrivacidad = () => {
  return (
    <div
      style={{
        background: 'linear-gradient(to bottom, #000B18, #133639)',
        minHeight: '100vh',
        color: '#fdf6d2',
        fontFamily: 'Arial, sans-serif',
        lineHeight: 1.6,
        margin: 0,
        padding: '20px',
      }}
    >
      <div
        style={{
          maxWidth: '900px',
          margin: '50px auto',
          padding: '40px',
          backgroundColor: 'rgba(0, 0, 0, 0.3)',
          borderRadius: '8px',
          boxShadow: '0 0 20px rgba(0, 0, 0, 0.5)',
          textAlign: 'justify',
        }}
      >
        <h1
          style={{
            textAlign: 'center',
            color: '#fdf6d2',
            borderBottom: '2px solid #fdf6d2',
            paddingBottom: '15px',
            marginBottom: '20px',
          }}
        >
          AVISO DE PRIVACIDAD
        </h1>

        <p>
          En cumplimiento a lo previsto por la Ley Federal de Protección de Datos Personales en Posesión de Particulares (“LFPDP”), VERSATILE COMMUNICATIONS,
          INC. (en lo sucesivo, “VERSATILE”), con domicilio en 9255 Sunset Blvd STE 1100 West Hollywod CA 90069, es considerada como responsable del uso y
          protección de sus datos personales, por lo que por este medio pone a su disposición y hace de su conocimiento el presente Aviso de Privacidad:
        </p>

        <h2>¿Qué datos vamos a recabar?</h2>
        <p>
          VERSATILE tratará datos personales de identificación, datos personales de contacto (nombre completo, correo electrónico, edad), datos personales de
          ubicación, datos de identificación de dispositivos, datos demográficos, incluyendo datos relativos a la ubicación geográfica del dispositivo que
          utilice para usar nuestros servicios, datos fiscales, datos personales patrimoniales y/o financieros, historial de reproducciones, e información que
          usted nos proporcione de manera voluntaria para la atención de quejas, reclamaciones o solicitudes de información.
        </p>

        <p>
          Le informamos que para efectos de lo señalado en el presente aviso de privacidad VERSATILE no tratará datos personales sensibles. Asimismo, VERSATILE
          tampoco recabará datos personales de personas menores de edad. En caso de que éstos se proporcionen, asumimos que los datos personales son otorgados
          por el padre, madre y/o tutor legal del menor de edad, quien reconoce haber leído el presente Aviso.
        </p>

        <h2>¿Para qué fines recabamos sus datos personales?</h2>
        <p>
          Los datos personales que VERSATILE recabe de usted serán utilizados principalmente para los siguientes fines necesarios para los servicios o productos
          que solicite: a) proporcionarle servicios de transmisión de contenido audiovisual vía satelital, streaming, SVoD, IPTV y demás medios, que nos ha
          solicitado; b) creación y gestión de un perfil de usuario, así como de recomendaciones y posibles intereses; c) identificación del contacto y
          posibilidad de contactarlo a través de distintos medios tales como teléfono o correo electrónico, con el fin de dar seguimiento a su pedido y
          cumplimiento a las obligaciones contraídas; d) acreditar su identidad; e) atender y resolver sus dudas relacionadas con los productos que adquiera; f)
          atender solicitudes de compra y procesar pagos; g) facilitar la localización, tramitación, suministro, distribución, y/o entrega de los productos
          solicitados por usted; h) realizar consultas y revisiones relacionadas con quejas y/o reclamaciones; i) gestionar la facturación del o de los
          servicios solicitados; j) informarle sobre cambios en el Sitio Web (como término se define más adelante); k) dar atención a sus solicitudes de
          información, quejas o reclamaciones; l) ayudarnos a detectar posibles riesgos y fraudes (en particular, su dirección IP) y, en general, para mejorar y
          optimizar el Sitio Web; y m) dar cumplimiento a las obligaciones nacidas por la relación jurídica en virtud de la adquisición de sus productos, todo
          lo anterior con el fin de darle a usted como usuario una experiencia más satisfactoria.
        </p>

        <p>
          De manera adicional, salvo que usted se oponga a ello, VERSATILE podrá utilizar sus datos personales para enviarle información sobre el lanzamiento de
          nuevos productos, o la realización de dinámicas, concursos o promociones sobre productos, y/o enviarle publicidad y comunicaciones con fines de
          mercadotecnia.
        </p>

        <h2>Uso de Cookies</h2>
        <p>
          VERSATILE utiliza varias tecnologías para mejorar la eficiencia de sus sitios web, incluyendo su experiencia cuando navega por dichos sitios. Entre
          estas tecnologías se incluye el uso de cookies. Las cookies son pequeñas cantidades de información que se almacenan en el navegador utilizado por cada
          usuario para que el servidor recuerde cierta información que posteriormente pueda utilizar. Esta información permite identificarle y guardar sus
          preferencias personales para brindarle una mejor experiencia de navegación. Le recordamos que usted puede deshabilitar o ajustar el uso de cookies
          siguiendo los procedimientos del navegador de internet que utiliza.
        </p>

        <p>
          En la función de Ayuda de la mayoría de los navegadores se indica cómo configurar su navegador para que no acepte cookies, para que le notifique cada
          vez que reciba una nueva cookie, o para desactivar todas las cookies. Asimismo, puede deshabilitar o eliminar datos similares que fueron utilizados
          por los complementos de los navegadores, tales como Flash Cookies, cambiando los ajustes de las extensiones o visitando la página Web de su
          fabricante. Sin embargo, le recomendamos que deje habilitadas las cookies a fin de aprovechar muchas de las funciones esenciales de
          http://umbra.stream.
        </p>

        <h2>¿Cómo ejercer sus Derechos ARCO?</h2>
        <p>
          Usted, o su representante legal, podrá ejercer cualquiera de los derechos de acceso, rectificación, cancelación u oposición (en lo sucesivo “Derechos
          ARCO”), así como revocar su consentimiento para el tratamiento de sus datos personales enviando un correo electrónico a la dirección electrónica
          contacto@morbido.tv.
        </p>

        <p>
          Su petición deberá ser realizada a través del Formato de Solicitud de Derechos ARCO, el cual debe ser solicitado a la dirección de correo electrónico
          antes señalada. Para que VERSATILE pueda darle seguimiento a su solicitud. Usted, o su representante legal, deberá acreditar correctamente su
          identidad para lo que es necesario que complete todos los campos indicados en el Formato y lo acompañe con copia de alguna de las identificaciones
          oficiales vigentes que se señalan en el mismo.
        </p>

        <p>
          Usted podrá limitar el uso o divulgación de sus datos personales enviando su solicitud a la misma dirección de correo electrónico señalada en el
          primer párrafo. En caso de que su Solicitud sea procedente, se le registrará en el listado de exclusión propio de VERSATILE.
        </p>

        <h2>Notificación de Cambios al presente Aviso</h2>
        <p>
          VERSATILE le notificará de cualquier cambio a su aviso de privacidad a través de nuestra página de internet http://umbra.stream (el “Sitio Web”), por
          lo cual le pedimos revise la misma de manera periódica.
        </p>

        <h2>INAI</h2>
        <p>
          En caso de considerarlo necesario, le informamos que tiene el derecho de acudir ante el Instituto Nacional de Transparencia, Acceso a la Información y
          Protección de Datos Personales (INAI) para hacer efectivos sus derechos.
        </p>

        <h2>Aceptación de términos</h2>
        <p>
          El presente Aviso de Privacidad está sujeto a los términos y condiciones de VERSATILE, lo cual constituye un acuerdo legal entre el usuario y
          nosotros. Si el usuario utiliza los servicios de VERSATILE en cualquiera de sus sitios, significa que ha leído, entendido y aceptado los términos
          antes expuestos.
        </p>
      </div>
    </div>
  );
};

export default AvisoPrivacidad;
